module.exports = __webpack_public_path__ + "745fcb9cdf4e65edc48f78d173367922.pdf";